import { LoanService } from '@/utils/service'
export const getDrpInfo = (params = {
  applyId: 0
}) => {
  return new LoanService({
    url: '/loan/drp/v1/info',
    method: 'get',
    data: {
      applyId: params.applyId
    }
  })
}
export const getDrpMonthAmount = (params = {
  applyId: 0,
  term: 0
}) => {
  return new LoanService({
    url: '/loan/drp/v1/month/amount',
    method: 'get',
    data: {
      applyId: params.applyId,
      term: params.term
    }
  })
}
export const drpSign = (params = {
  applyId: 0,
  term: 0
}) => {
  return new LoanService({
    url: '/loan/drp/v1/sign',
    method: 'post',
    data: {
      applyId: params.applyId,
      term: params.term
    }
  })
}
